import { Route } from 'types/route.type';
import FarmOverview from './farm-overview';

export const routes: Route[] = [
  {
    path: '/production-systems/farm-overview/:globalSiteId?',
    component: FarmOverview,
    id: 'productionSystems.farmOverview.title',
  },
];
